import React from "react";
import * as THREE from "three";

const Column3D = ({ column, gridScaleX, gridScaleY }) => {
    // console.log("Normal Column", column);
    const { x, y } = column.values.point;
    const outreach = column.values.outreach || 0;
    const height = column.values.height || 6;
    const radius = 0.2;
    const color = column.color === '#FFA500 ' ? "orange" : column.color;
    const positionAngle = column.values.positionAngle || 0;
    const tiltDeg = column.values.tilt ?? 0;

    const outreachWidth = 0.75 * outreach;
    const outreachHeight = 0.2;
    const outreachDepth = 0.2;
    const safeScaleX = gridScaleX || 1;
    const safeScaleY = gridScaleY || 1;

    // Parent group in StageCanvas is rotated on X, so negative local Z draws upward.
    const columnBaseZ = -height / 2;
    const renderX = x / safeScaleX;
    const renderY = (y * -1) / safeScaleY;

    const topOfColumn = [
        renderX,
        renderY,
        columnBaseZ - height / 2 + 0.05,
    ];

    const normalize360 = (angle) => ((Number(angle) % 360) + 360) % 360;
    const baseAngle = normalize360(positionAngle ?? 0);
    // Match mast angle convention so 3D column faces same direction as transformer/UI.
    const angleRad = (baseAngle + 90) * (Math.PI / 180);
    const direction = new THREE.Vector3(Math.cos(angleRad), -Math.sin(angleRad), 0);

    const halfOutreachWidth = (outreachWidth) / 2;
    const baseOffset = direction.clone().multiplyScalar(halfOutreachWidth);

    const tiltRad = (tiltDeg * Math.PI) / 180;

    let inwardOffset = Math.sin(tiltRad) * (outreachHeight) / 2;
    let upwardOffset = Math.sin(tiltRad) * (outreachDepth) / 2;

    if (tiltDeg < 0) {
        inwardOffset *= -1;
        upwardOffset *= -1;
    }
    const xRot = tiltRad;
    const yRot = 0;

    // console.log("Column 3D", { x, y, radius, height, color, outreach, positionAngle, tiltDeg, angleRad, direction, baseOffset, inwardOffset, upwardOffset, topOfColumn, direction });

    return (
        <>
            {/* Column */}
            <mesh position={[renderX, renderY, columnBaseZ]} rotation={[Math.PI / 2, 0, 0]}>
                <cylinderGeometry args={[radius, radius, height, 32]} />
                <meshStandardMaterial color={color} />
            </mesh>

            {/* Outreach Box */}
            <mesh
                position={[
                    topOfColumn[0] + (baseOffset.x - inwardOffset * direction.x) / safeScaleX,
                    topOfColumn[1] + (baseOffset.y - inwardOffset * direction.y) / safeScaleY,
                    topOfColumn[2] + outreachHeight / 2 + upwardOffset,
                ]}
                rotation={[xRot, yRot, -angleRad]}
            >
                <boxGeometry args={[outreachWidth, outreachHeight, outreachDepth]} />
                <meshStandardMaterial color={color} />
            </mesh>
        </>
    );
};

export default Column3D;
